import { render, staticRenderFns } from "./FatworaDetailByIDStore.vue?vue&type=template&id=1912f4dc&"
import script from "./FatworaDetailByIDStore.vue?vue&type=script&lang=js&"
export * from "./FatworaDetailByIDStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/projects/accurate/acc-dashboard/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {VIcon})
